import DATA_URI_GIF_PREFIX from "constants/DataUriGifPrefix";

export default function isDataUriGif(uri: string): boolean {
  return uri.includes(DATA_URI_GIF_PREFIX);
}
